/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedAndSyncedResultProductClaimSummary,
  PagedResultClaimableInvoiceItem,
  ProductClaimDetailProjection,
  ProductClaimProcessingStatus,
  ProductClaimReason,
  SortDirection,
} from '../models/index';
import {
    PagedAndSyncedResultProductClaimSummaryFromJSON,
    PagedAndSyncedResultProductClaimSummaryToJSON,
    PagedResultClaimableInvoiceItemFromJSON,
    PagedResultClaimableInvoiceItemToJSON,
    ProductClaimDetailProjectionFromJSON,
    ProductClaimDetailProjectionToJSON,
    ProductClaimProcessingStatusFromJSON,
    ProductClaimProcessingStatusToJSON,
    ProductClaimReasonFromJSON,
    ProductClaimReasonToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface CreateProductClaimRequest {
    reason: string;
    preferredSettlement: string;
    description: string;
    invoiceItemId: string;
    serialNumber?: string;
    deliveryDeviation?: number;
    files?: Array<Blob>;
}

export interface GetAttachmentRequest {
    claimId: string;
    attachmentId: string;
}

export interface GetClaimableInvoiceItemsOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    sortByHeoItemId?: SortDirection;
    sortByInvoiceCreatedAt?: SortDirection;
    sortByInvoiceNumber?: SortDirection;
    sortByInvoiceTotal?: SortDirection;
    sortByCustomerOrderNumber?: SortDirection;
    sortByProductOriginCountry?: SortDirection;
    sortByProductTariffNumber?: SortDirection;
    sortByProductNumber?: SortDirection;
    sortByQuantity?: SortDirection;
    sortByPricePerUnit?: SortDirection;
    sortByDiscount?: SortDirection;
    sortByDiscountedPricePerUnit?: SortDirection;
    sortByTotal?: SortDirection;
    sortByCustomerItemReference?: SortDirection;
    fulltextQuery?: string;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
}

export interface GetProductClaimDetailRequest {
    claimId: string;
}

export interface GetProductClaimSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    productNumber?: string;
    processingStatus?: Array<ProductClaimProcessingStatus>;
    fullTextQuery?: string;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    reasons?: Array<ProductClaimReason>;
    sortByCreatedAt?: SortDirection;
    sortByNumber?: SortDirection;
    sortByProductNumber?: SortDirection;
    sortByInvoiceNumber?: SortDirection;
    sortByReason?: SortDirection;
    sortByStatus?: SortDirection;
    sortByProcessingStatus?: SortDirection;
    sortByRmaNumber?: SortDirection;
    sortByCreditNoteNumber?: SortDirection;
}

/**
 * 
 */
export class ClaimRessourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for createProductClaim without sending the request
     */
    async createProductClaimRequestOpts(requestParameters: CreateProductClaimRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['reason'] == null) {
            throw new runtime.RequiredError(
                'reason',
                'Required parameter "reason" was null or undefined when calling createProductClaim().'
            );
        }

        if (requestParameters['preferredSettlement'] == null) {
            throw new runtime.RequiredError(
                'preferredSettlement',
                'Required parameter "preferredSettlement" was null or undefined when calling createProductClaim().'
            );
        }

        if (requestParameters['description'] == null) {
            throw new runtime.RequiredError(
                'description',
                'Required parameter "description" was null or undefined when calling createProductClaim().'
            );
        }

        if (requestParameters['invoiceItemId'] == null) {
            throw new runtime.RequiredError(
                'invoiceItemId',
                'Required parameter "invoiceItemId" was null or undefined when calling createProductClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['serialNumber'] != null) {
            formParams.append('serialNumber', requestParameters['serialNumber'] as any);
        }

        if (requestParameters['reason'] != null) {
            formParams.append('reason', requestParameters['reason'] as any);
        }

        if (requestParameters['preferredSettlement'] != null) {
            formParams.append('preferredSettlement', requestParameters['preferredSettlement'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }

        if (requestParameters['invoiceItemId'] != null) {
            formParams.append('invoiceItemId', requestParameters['invoiceItemId'] as any);
        }

        if (requestParameters['deliveryDeviation'] != null) {
            formParams.append('deliveryDeviation', requestParameters['deliveryDeviation'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('files', element as any);
            })
        }


        let urlPath = `/api/v1/ui/claim/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async createProductClaimRaw(requestParameters: CreateProductClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createProductClaimRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createProductClaim(requestParameters: CreateProductClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createProductClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAttachment without sending the request
     */
    async getAttachmentRequestOpts(requestParameters: GetAttachmentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getAttachment().'
            );
        }

        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError(
                'attachmentId',
                'Required parameter "attachmentId" was null or undefined when calling getAttachment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/claim/{claimId}/attachment/{attachmentId}`;
        urlPath = urlPath.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId'])));
        urlPath = urlPath.replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAttachmentRaw(requestParameters: GetAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.getAttachmentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async getAttachment(requestParameters: GetAttachmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getClaimableInvoiceItemsOfCurrentRetailer without sending the request
     */
    async getClaimableInvoiceItemsOfCurrentRetailerRequestOpts(requestParameters: GetClaimableInvoiceItemsOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['sortByHeoItemId'] != null) {
            queryParameters['sortByHeoItemId'] = requestParameters['sortByHeoItemId'];
        }

        if (requestParameters['sortByInvoiceCreatedAt'] != null) {
            queryParameters['sortByInvoiceCreatedAt'] = requestParameters['sortByInvoiceCreatedAt'];
        }

        if (requestParameters['sortByInvoiceNumber'] != null) {
            queryParameters['sortByInvoiceNumber'] = requestParameters['sortByInvoiceNumber'];
        }

        if (requestParameters['sortByInvoiceTotal'] != null) {
            queryParameters['sortByInvoiceTotal'] = requestParameters['sortByInvoiceTotal'];
        }

        if (requestParameters['sortByCustomerOrderNumber'] != null) {
            queryParameters['sortByCustomerOrderNumber'] = requestParameters['sortByCustomerOrderNumber'];
        }

        if (requestParameters['sortByProductOriginCountry'] != null) {
            queryParameters['sortByProductOriginCountry'] = requestParameters['sortByProductOriginCountry'];
        }

        if (requestParameters['sortByProductTariffNumber'] != null) {
            queryParameters['sortByProductTariffNumber'] = requestParameters['sortByProductTariffNumber'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        if (requestParameters['sortByQuantity'] != null) {
            queryParameters['sortByQuantity'] = requestParameters['sortByQuantity'];
        }

        if (requestParameters['sortByPricePerUnit'] != null) {
            queryParameters['sortByPricePerUnit'] = requestParameters['sortByPricePerUnit'];
        }

        if (requestParameters['sortByDiscount'] != null) {
            queryParameters['sortByDiscount'] = requestParameters['sortByDiscount'];
        }

        if (requestParameters['sortByDiscountedPricePerUnit'] != null) {
            queryParameters['sortByDiscountedPricePerUnit'] = requestParameters['sortByDiscountedPricePerUnit'];
        }

        if (requestParameters['sortByTotal'] != null) {
            queryParameters['sortByTotal'] = requestParameters['sortByTotal'];
        }

        if (requestParameters['sortByCustomerItemReference'] != null) {
            queryParameters['sortByCustomerItemReference'] = requestParameters['sortByCustomerItemReference'];
        }

        if (requestParameters['fulltextQuery'] != null) {
            queryParameters['fulltextQuery'] = requestParameters['fulltextQuery'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/claim/claimable-invoice-items`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getClaimableInvoiceItemsOfCurrentRetailerRaw(requestParameters: GetClaimableInvoiceItemsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedResultClaimableInvoiceItem>> {
        const requestOptions = await this.getClaimableInvoiceItemsOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedResultClaimableInvoiceItemFromJSON(jsonValue));
    }

    /**
     */
    async getClaimableInvoiceItemsOfCurrentRetailer(requestParameters: GetClaimableInvoiceItemsOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedResultClaimableInvoiceItem> {
        const response = await this.getClaimableInvoiceItemsOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProductClaimDetail without sending the request
     */
    async getProductClaimDetailRequestOpts(requestParameters: GetProductClaimDetailRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getProductClaimDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/claim/{claimId}`;
        urlPath = urlPath.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductClaimDetailRaw(requestParameters: GetProductClaimDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductClaimDetailProjection>> {
        const requestOptions = await this.getProductClaimDetailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductClaimDetailProjectionFromJSON(jsonValue));
    }

    /**
     */
    async getProductClaimDetail(requestParameters: GetProductClaimDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductClaimDetailProjection> {
        const response = await this.getProductClaimDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getProductClaimSummariesOfCurrentRetailer without sending the request
     */
    async getProductClaimSummariesOfCurrentRetailerRequestOpts(requestParameters: GetProductClaimSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['productNumber'] != null) {
            queryParameters['productNumber'] = requestParameters['productNumber'];
        }

        if (requestParameters['processingStatus'] != null) {
            queryParameters['processingStatus'] = requestParameters['processingStatus'];
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['reasons'] != null) {
            queryParameters['reasons'] = requestParameters['reasons'];
        }

        if (requestParameters['sortByCreatedAt'] != null) {
            queryParameters['sortByCreatedAt'] = requestParameters['sortByCreatedAt'];
        }

        if (requestParameters['sortByNumber'] != null) {
            queryParameters['sortByNumber'] = requestParameters['sortByNumber'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        if (requestParameters['sortByInvoiceNumber'] != null) {
            queryParameters['sortByInvoiceNumber'] = requestParameters['sortByInvoiceNumber'];
        }

        if (requestParameters['sortByReason'] != null) {
            queryParameters['sortByReason'] = requestParameters['sortByReason'];
        }

        if (requestParameters['sortByStatus'] != null) {
            queryParameters['sortByStatus'] = requestParameters['sortByStatus'];
        }

        if (requestParameters['sortByProcessingStatus'] != null) {
            queryParameters['sortByProcessingStatus'] = requestParameters['sortByProcessingStatus'];
        }

        if (requestParameters['sortByRmaNumber'] != null) {
            queryParameters['sortByRmaNumber'] = requestParameters['sortByRmaNumber'];
        }

        if (requestParameters['sortByCreditNoteNumber'] != null) {
            queryParameters['sortByCreditNoteNumber'] = requestParameters['sortByCreditNoteNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/claim`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductClaimSummariesOfCurrentRetailerRaw(requestParameters: GetProductClaimSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedAndSyncedResultProductClaimSummary>> {
        const requestOptions = await this.getProductClaimSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedAndSyncedResultProductClaimSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getProductClaimSummariesOfCurrentRetailer(requestParameters: GetProductClaimSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedAndSyncedResultProductClaimSummary> {
        const response = await this.getProductClaimSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
